
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button,} from "react-bootstrap";
import CardItem from "../CardItem";
import { dummyProducts } from "../dummyprduct";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../Config";


const SeaFood: React.FC = () => {
    const [products, setProducts] = useState<any[]>([]);
    const navigate = useNavigate();
  
    const getAllProduct = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/api/product?category=fish-sea-foods&page=1&limit=6&isDeleted=false`
        );
        if (response.data?.products?.length) {
          setProducts(response.data.products);
        } else {
          setProducts([]);
        }
      } catch (error) {
        console.error(error);
      }
    };
  
    const handleNavChicken = () => {
      navigate("/chicken");
    };
  
    useEffect(() => {
      getAllProduct();
    }, []);
  return (
    <section className="py-5">
      <Container>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="fw-bold">Buy Sea food Online</h2>
          <Button variant="light" className="fw-bold"  onClick={()=>navigate("/fish&sea-foods")}>
            See More →
          </Button>
        </div>
        <Row className="g-4">
          {products?.map((product) => (
            <Col key={product._id} md={3} sm={6} xs={6}>
              <CardItem product={product}/>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default SeaFood;
